import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cart-page"
export default class extends Controller {
  static targets = ["totalPrice"]

  async update(event) {
    const button = event.target.closest("[data-sku-id]")
    if (!button) return

    const id = button.dataset.skuId
    const quantity = parseInt(button.dataset.quantity, 10)

    if (quantity >= 0) {
      await this._sendUpdate(id, quantity)
    }
  }

  async remove(event) {
    event.preventDefault()
    const button = event.target.closest("[data-sku-id]")
    if (!button) return

    const id = button.dataset.skuId
    await this._sendUpdate(id, 0)
  }

  async applyCoupon(event) {
    event.preventDefault()
    const input = document.getElementById("coupon-code-input")
    const code = input?.value?.trim()
    if (!code) return

    await this._sendCouponRequest("/cart/apply_coupon.js", { code })
  }

  async removeCoupon(event) {
    event.preventDefault()
    await this._sendCouponRequest("/cart/remove_coupon.js", {})
  }

  async _sendCouponRequest(url, body) {
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(body)
      })
      const data = await res.json()

      if (res.ok) {
        window.location.reload()
      } else {
        const errorEl = document.getElementById("coupon-error-message")
        if (errorEl) {
          errorEl.textContent = data.error || "Không thể áp dụng mã giảm giá"
          errorEl.classList.remove("hidden")
        }
      }
    } catch (err) {
      alert("Network error")
    }
  }

  async _sendUpdate(id, quantity) {
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ sku_id: id, quantity })
      })

      if (res.ok) {
        // Reload page to get updated cart HTML
        window.location.reload()
      } else {
        alert("Failed to update cart")
      }
    } catch (err) {
      alert("Network error")
    }
  }
}
